import React from 'react';
import { Link } from 'react-router-dom';
import sam5 from '../../img/TopSakura.png';
import kaki from '../../img/Book1.jpg';
import question from '../../img/TopQuestion.JPEG';
import schedule from '../../img/TopSchedule.JPEG';
import sam8 from '../../img/TopFlow.JPEG';
// import ImportantNews from './ImportantNews.jsx';
import styled from 'styled-components';

const url = '/yotsutaninet/';


// const MarginWidthHalf =styled.img`
//     margin: 0 auto;
//     width: 50%;
// `;

const BtnClick3 = () => {
    let element = document.getElementById("blog3");

    // 表示・非表示を切り替える
    let a = element.className;
    if (a === 'd-block') {
        element.className = "d-none";
    } else {
        element.className = "d-block";
    }
}
const BtnClick2 = () => {
    let element = document.getElementById("blog2");

    // 表示・非表示を切り替える
    let b = element.className;
    if (b === 'd-block') {
        element.className = "d-none";
    } else {
        element.className = "d-block";
    }
}
const BtnClick1 = () => {
    let element = document.getElementById("blog1");

    // 表示・非表示を切り替える
    let b = element.className;
    element.className = b === 'd-block' ? "d-none" : "d-block";
}

// 重要なお知らせ
const NewsPadding = styled.div`
    padding-top: 70px;
    padding-bottom: 70px;
`;

const BtnNone = styled.button`
    border: 0;
    background-color: #fff;
`;

const NewsTitle = styled.h3`
    border-bottom: 2px solid indianred;
`;


const NewsComment = styled.div`
    padding: 20px;
    font-weight: bold;
`;
const BorderNoneMarginWid = styled.div`
    border: 0!important;
    margin:0 auto;
    width: 80%;
`;

const NewsBackColor = styled.div`
    padding-top: 70px;
    padding-bottom: 70px;
    background-image:  linear-gradient(0deg, #990820 0%, #ba0020 100%) !important;
    color: #fff;
`;


// 各ページの案内
const Introduction = styled.div`
    padding:30px 0px 30px;
    margin:30px 0px 30px;
    background-image:  linear-gradient(0deg, #990820 0%, #ba0020 100%) !important;
`;

const MarginWidthSeven = styled.div`
    margin: 0 auto;
    width: 90%;
`;

//　画像背景画像
const ImgText = styled.h3`
    margin:auto;
    color: #fff;
    font-weight: bold;
    padding: 10px;
    border-radius: 7px;
    font-size: 35px;
    letter-spacing: 5px;
`;

const SvgColor = styled.span`
    color: red;
`;
const SvgColorPink = styled.span`
    color: hotpink;
`;

const SinendHakotiraA = styled.p`
   text-align: left;
`;
const SinendHakotiraB = styled.p`
  text-align: left;
   padding-left: 19px; 
`;




const ImgTextTrialRecord = styled(ImgText)`background-color: lightpink;`;

const Main = () => {
    return (
        <>
            {/* お知らせ欄 */}

            {/* <BorderNone className="card mb-3 text-center mt-5">
                <MarginWidthHalf src={sam3} class="card-img-top" />
                <div class="card-body">
                    <a href="https://www.yotsuyaotsuka.com/toitsutest/" className="btn btn-danger" target="_black">お申込みはこちら</a>
                </div>
           </BorderNone> */}


            {/* 重要なお知らせ */}
            <BorderNoneMarginWid className="card mb-3">
                <div className="row g-0" >
                    <NewsBackColor className="col-md-2 d-flex align-items-center justify-content-center" >
                        <h3 >お知らせ</h3>
                    </NewsBackColor>
                    <NewsPadding className="col-md-10">
                        <div className="card-body">
                            {/* <Link to={url + 'Winter'}>
                            <BtnNone className="btn-none mt-3" >
                                <NewsTitle>2021年&ensp;冬期講座生募集!</NewsTitle>
                            </BtnNone></Link><br /> */}


                            <BtnNone className="btn-none mt-3">
                                <NewsTitle>
                                    {/* <SvgColorPink>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-flower3" viewBox="0 0 16 16">
                                        <path d="M11.424 8c.437-.052.811-.136 1.04-.268a2 2 0 0 0-2-3.464c-.229.132-.489.414-.752.767C9.886 4.63 10 4.264 10 4a2 2 0 1 0-4 0c0 .264.114.63.288 1.035-.263-.353-.523-.635-.752-.767a2 2 0 0 0-2 3.464c.229.132.603.216 1.04.268-.437.052-.811.136-1.04.268a2 2 0 1 0 2 3.464c.229-.132.489-.414.752-.767C6.114 11.37 6 11.736 6 12a2 2 0 1 0 4 0c0-.264-.114-.63-.288-1.035.263.353.523.635.752.767a2 2 0 1 0 2-3.464c-.229-.132-.603-.216-1.04-.268zM9 4a1.468 1.468 0 0 1-.045.205c-.039.132-.1.295-.183.484a12.88 12.88 0 0 1-.637 1.223L8 6.142a21.73 21.73 0 0 1-.135-.23 12.88 12.88 0 0 1-.637-1.223 4.216 4.216 0 0 1-.183-.484A1.473 1.473 0 0 1 7 4a1 1 0 1 1 2 0zM3.67 5.5a1 1 0 0 1 1.366-.366 1.472 1.472 0 0 1 .156.142c.094.1.204.233.326.4.245.333.502.747.742 1.163l.13.232a21.86 21.86 0 0 1-.265.002 12.88 12.88 0 0 1-1.379-.06 4.214 4.214 0 0 1-.51-.083 1.47 1.47 0 0 1-.2-.064A1 1 0 0 1 3.67 5.5zm1.366 5.366a1 1 0 0 1-1-1.732c.001 0 .016-.008.047-.02.037-.013.087-.028.153-.044.134-.032.305-.06.51-.083a12.88 12.88 0 0 1 1.379-.06c.09 0 .178 0 .266.002a21.82 21.82 0 0 1-.131.232c-.24.416-.497.83-.742 1.163a4.1 4.1 0 0 1-.327.4 1.483 1.483 0 0 1-.155.142zM9 12a1 1 0 0 1-2 0 1.476 1.476 0 0 1 .045-.206c.039-.131.1-.294.183-.483.166-.378.396-.808.637-1.223L8 9.858l.135.23c.241.415.47.845.637 1.223.083.19.144.352.183.484A1.338 1.338 0 0 1 9 12zm3.33-6.5a1 1 0 0 1-.366 1.366 1.478 1.478 0 0 1-.2.064c-.134.032-.305.06-.51.083-.412.045-.898.061-1.379.06-.09 0-.178 0-.266-.002l.131-.232c.24-.416.497-.83.742-1.163a4.1 4.1 0 0 1 .327-.4c.046-.05.085-.086.114-.11.026-.022.04-.03.041-.032a1 1 0 0 1 1.366.366zm-1.366 5.366a1.494 1.494 0 0 1-.155-.141 4.225 4.225 0 0 1-.327-.4A12.88 12.88 0 0 1 9.74 9.16a22 22 0 0 1-.13-.232l.265-.002c.48-.001.967.015 1.379.06.205.023.376.051.51.083.066.016.116.031.153.044l.048.02a1 1 0 1 1-1 1.732zM8 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                    </svg>
                                    </SvgColorPink> */}
                                    <Link to={url + 'Success'} style={{ color: 'black' }} className="text-decoration-none">2025年度 <span className='fs-2' style={{ color: 'indianred' }}>合格速報</span>はこちら

                                    </Link>
                                </NewsTitle>
                            </BtnNone><br />
                            <div className="d-block " id="blog1" value="1">
                                <NewsComment className="Blog-comment">
                                    {/* <p>灘中学・・１名(全員合格)</p> */}
                                    <p>土佐中学・・７名(全員合格)</p>
                                    <p>土佐塾中・・３名(全員合格) ※内特待生２名</p>
                                    <p>ラサール中学・・５名(全員合格)</p>
                                    <p>四天王寺中学（英数コース）・・１名(全員合格)</p>
                                    <p>品川女子学院中学・・１名(全員合格)</p>
                                    <p>近畿大学附属中学校・・２名(全員合格)</p>
                                    <p>開智中学校・・１名(全員合格)</p>
                                    <p>開智所沢中学校・・１名(全員合格)</p>
                                    {/*<p>東大寺学園中学・・１名(２名受験)</p>
                                    <p>目黒日本大学中学・・１名(全員合格)</p>
                                    <p>学習院中等科・・１名(全員合格)</p> */}
                                    {/* <p>西大和学園中学・・２名(３名受験)</p> */}
                                    <p>愛光中学・・７名(１０名受験)</p>
                                    {/* <p>巣鴨中学・・１名(全員合格)</p> */}
                                    {/* <p>城北中学・・１名(全員合格)</p> */}
                                    <p>岡山中学(東医コース)・・２名(全員合格)</p>
                                    <p>岡山中学(難関コース)・・２名(全員合格)</p>
                                    <p></p>
                                    <p>はりまやYT教室生の合格実績です。</p>

                                </NewsComment>
                            </div>
                            <BtnNone className="btn-none mt-3" >
                                <NewsTitle>
                                        <a href="https://www.tosajuku.com/ytSummer.pdf" style={{color:'black'}} className="text-decoration-none">夏期講座のご案内はこちら

                                        </a>
                                        {/* <img src={kaki} style={{width: '100%'}} /> */}
                                </NewsTitle>
                            </BtnNone><br/>

                            {
                            /* <BtnNone className="btn-none mt-3" >
                                <NewsTitle>
                                        <a href="https://www.tosajuku.com/ytWinter.pdf" style={{color:'black'}}>冬期講座の時間割はこちら&nbsp;
                                            <SvgColor>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-right-square" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.854 8.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>
                                                    </svg>
                                            </SvgColor>
                                        </a>
                                </NewsTitle>
                            </BtnNone><br/>
                            */}
                            <BtnNone className="btn-none mt-4" >
                                <NewsTitle>
                                    <a href="https://www.tosajuku.com/newsTest.pdf" style={{ color: 'black' }}>教室説明会&nbsp;/ 入室テストの予定はこちら

                                    </a>
                                </NewsTitle>
                            </BtnNone><br />
  
                            {/* <BtnNone className="btn-none mt-4" >
                                <NewsTitle>
                                        <a href="https://www.tosajuku.com/Schedule202409.pdf" style={{color:'black'}}>９月の行事予定表はこちら&nbsp;

                                        </a>
                                </NewsTitle>
                            </BtnNone><br/> */}


                            <BtnNone className="btn-none mt-4" >
                                <NewsTitle>
                                    <a href="https://www.tosajuku.com/timeSpring.pdf" style={{ color: 'black' }}>新年度時間割 ３月以降 小３〜小６&nbsp;</a>
                                </NewsTitle>
                                <div>
                                    <SinendHakotiraA>※小３の授業は3月スタートになります。</SinendHakotiraA>
                                    <SinendHakotiraB>  小５・小６は授業曜日に変更があります。</SinendHakotiraB>
                                    <SinendHakotiraB>  ご注意してください。</SinendHakotiraB>
                                </div>

                            </BtnNone><br />


                            <BtnNone className="btn-none mt-4" onClick={BtnClick3}>
                                <NewsTitle>YT生 「土佐塾模試 成績推移表」はこちら&nbsp;
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" /></svg>
                                </NewsTitle>
                            </BtnNone><br />
                            <div className="d-none " id="blog3" value="1">
                                <NewsComment className="Blog-comment">
                                    <p class="mt-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-filetype-pdf" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z" /></svg><a href="https://www.tosajuku.com/transition2023Y4.pdf">&nbsp;4YTコース成績推移表</a></p>
                                    <p class="mt-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-filetype-pdf" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z" /></svg><a href="https://www.tosajuku.com/transition2023Y5.pdf">&nbsp;5YTコース成績推移表</a></p>
                                    <p class="mt-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-filetype-pdf" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z" /></svg><a href="https://www.tosajuku.com/transition2023Y6.pdf">&nbsp;6YTコース成績推移表</a></p>
                                </NewsComment>
                            </div>

                        </div>
                    </NewsPadding>
                </div>

            </BorderNoneMarginWid>


            {/* 各ページの案内 */}
            <Introduction>
                <MarginWidthSeven className="row row-cols-1 row-cols-md-2 g-4 " >
                    <div className="col">
                        <Link to={url + 'Join'}>
                            <img src={sam8} className="card-img" alt="..." />
                            <div className="card-img-overlay d-flex align-items-center">
                                <ImgText className="card-title">入塾の流れ</ImgText>
                            </div>
                        </Link>
                    </div>

                    <div className="col">
                        <Link to={url + 'TrialRecord'}>
                            <img src={sam5} class="card-img-top" alt="..." />
                            <div className="card-img-overlay d-flex align-items-center">
                                <ImgTextTrialRecord className="card-title">合格体験記</ImgTextTrialRecord>
                            </div>
                        </Link>
                    </div>

                    <div className="col">
                        <Link to={url + 'Faq'}>
                            <img src={question} className="card-img" alt="..." />
                            <div className="card-img-overlay d-flex align-items-center">
                                <ImgText className="card-title">よくあるご質問</ImgText>
                            </div>
                        </Link>
                    </div>

                    <div className="col">
                        <Link to={url + 'Information'}>
                            <img src={schedule} className="card-img" alt="..." />
                            <div className="card-img-overlay d-flex align-items-center">
                                <ImgText className="card-title">月間スケジュール</ImgText>
                            </div>
                        </Link>
                    </div>
                </MarginWidthSeven>
            </Introduction>
        </>

    );
};

export default Main;